import { Component, OnInit, OnDestroy } from '@angular/core';
import { slideToRight } from '../router-animation/router-animation.component';
import { DatabaseService } from 'src/_services/DatabaseService';
import { Router, ActivatedRoute } from '@angular/router';
import { sessionStorage } from '../localstorage.service';
import { DialogComponent } from '../dialog.component';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']

})
export class LoginComponent implements OnInit, OnDestroy {

  data: any = [];
  peraluser: any = {};
  st_user: any = {}; 
  nexturl: any;
  channel_partner: boolean = false;
  cp_otp: any;
  edit_view: boolean = false;
  tokenInfo: any = '';
  showPassword: boolean = false;
  savingFlag: boolean = false;
  rememberMe: boolean = true;

  banners: any[] = [
    { image: 'https://wigwamply.com/wp-content/uploads/2025/11/Wigwam-Desktop-Hero-Images-05.webp', alt: 'Wigwam Banner 1' },
    { image: 'https://wigwamply.com/wp-content/uploads/2025/11/Wigwam-Desktop-Hero-Images-07.webp', alt: 'Wigwam Banner 2' },
    { image: 'https://wigwamply.com/wp-content/uploads/2025/11/Wigwam-Desktop-Hero-Images-06.webp', alt: 'Wigwam Banner 3' },
    { image: 'https://wigwamply.com/wp-content/uploads/2025/11/Wigwam-Desktop-Hero-Images-08.webp', alt: 'Wigwam Banner 4' }
  ];

  // ── PWA install ─────────────────────────────────────────────
  // Hidden only once the app is already running installed; every browser /
  // screen size otherwise gets the button. Chrome & co. get the native prompt,
  // the rest (iOS Safari, Firefox, desktop Safari) get manual steps.
  deferredPrompt: any = null;
  showInstall: boolean = false;
  showInstallHelp: boolean = false;
  installSteps: string[] = [];

  constructor(public serve: DatabaseService, public rout: Router, public session: sessionStorage, public dialog: DialogComponent, private route: ActivatedRoute, private router: Router) { }

  ngOnInit() {
    const savedUser = localStorage.getItem('remembered_username');
    if (savedUser) {
      this.data['username'] = savedUser;
      this.rememberMe = true;
    }

    this.showInstall = !this.isStandalone();
    this.pickUpInstallPrompt();
    window.addEventListener('wg-install-available', this.pickUpInstallPrompt);
    window.addEventListener('wg-install-done', this.onAppInstalled);
  }

  ngOnDestroy() {
    window.removeEventListener('wg-install-available', this.pickUpInstallPrompt);
    window.removeEventListener('wg-install-done', this.onAppInstalled);
  }

  // Arrow properties so add/removeEventListener see the same reference.
  private pickUpInstallPrompt = () => {
    this.deferredPrompt = (window as any).__wgInstallPrompt || null;
  }

  private onAppInstalled = () => {
    this.deferredPrompt = null;
    this.showInstall = false;
    this.showInstallHelp = false;
  }

  private isStandalone(): boolean {
    return (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
      || (navigator as any).standalone === true
      || document.referrer.indexOf('android-app://') === 0;
  }

  installApp() {
    if (this.deferredPrompt) {
      this.showInstallHelp = false;
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choice: any) => {
        this.deferredPrompt = null;
        (window as any).__wgInstallPrompt = null;
        if (choice && choice.outcome === 'accepted') { this.showInstall = false; }
      });
      return;
    }
    // No native prompt available — show how to do it by hand instead.
    this.installSteps = this.manualInstallSteps();
    this.showInstallHelp = !this.showInstallHelp;
  }

  private manualInstallSteps(): string[] {
    const ua = navigator.userAgent || '';
    const isIos = /iPad|iPhone|iPod/.test(ua) || (/Macintosh/.test(ua) && (navigator as any).maxTouchPoints > 1);

    if (isIos) {
      return [
        'Safari me yeh page kholein',
        'Neeche Share (⬆) button dabayein',
        '"Add to Home Screen" chunein',
        'Add par tap karein — app home screen par aa jayegi'
      ];
    }
    if (/Firefox/.test(ua)) {
      return [
        'Browser menu (⋮ / ☰) kholein',
        '"Install" ya "Add to Home screen" chunein',
        'Confirm karein'
      ];
    }
    return [
      'Address bar ke right me install (⊕) icon dabayein',
      'Ya browser menu (⋮) → "Install app" / "Add to Home screen" chunein',
      'Confirm karein — app alag window me khulegi'
    ];
  }

  login() {
    this.savingFlag = true;
    if (this.rememberMe) {
      localStorage.setItem('remembered_username', this.data['username']);
    } else {
      localStorage.removeItem('remembered_username');
    }
    let value = { "username": this.data['username'], "password": this.data['password'] }
    this.serve.auth_rqust(value, "login/submitnew").subscribe((data: any) => {

      let user = data['data'];
      if (data['data']['id'] != '1' && data['data']['user_type'] != 'DMS') {
        // console.log(data['assignModule'])
        for (let i = 0; i < data['assignModule'].length; i++) {
          // console.log(data['assignModule'][i]['view'] == 'true')
          // console.log(data['assignModule'][i]['module_name'])

          if (data['assignModule'][i]['module_name'] == 'Dashboard' && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_dashboard'] = 1
          }




          else if (data['assignModule'][i]['module_name'] == 'OTP Logs' && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_otp_log'] = 1
          }
          else if (data['assignModule'][i]['module_name'] == 'Petrol Tracker' && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_petrol_tracker'] = 1

            if (data['assignModule'][i]['export'] == 'true') {
              data['data']['export_petrol_tracker'] = 1
            }
            if (data['assignModule'][i]['add'] == 'true') {
              data['data']['add_petrol_tracker'] = 1
            }
            if (data['assignModule'][i]['edit'] == 'true') {
              data['data']['edit_petrol_tracker'] = 1
            }
          }
       
         
          else if ((data['assignModule'][i]['module_name'] == 'User REQ') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_userReq'] = 1

          }
             else if ((data['assignModule'][i]['module_name'] == 'Inventory') && data['assignModule'][i]['view'] == 'true') {

            data['data']['view_Inventory'] = 1

          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Dashboard') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_dashboard'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Department') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_department'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Category') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_category'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Sub-Category') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_subcategory'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Unit') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_unit'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Product') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_product'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Vendor') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_vendor'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - MRN') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_mrn'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Stock Out') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_stockout'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Gate Pass') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_gatepass'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Returnable') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_returnable'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Dead Stock') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_deadstock'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Inventory - Ledger') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Inventory'] = 1
            data['data']['view_inv_ledger'] = 1
          }

          // ── Security ──────────────────────────────────────────────
          else if ((data['assignModule'][i]['module_name'] == 'Security - Visitor') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Security'] = 1
            data['data']['view_sec_visitor'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Security - Gate Pass') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Security'] = 1
            data['data']['view_sec_gatepass'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Security - Patrol') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Security'] = 1
            data['data']['view_sec_patrol'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Security - Attendance') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_Security'] = 1
            data['data']['view_sec_attendance'] = 1
          }

          // ── HR ────────────────────────────────────────────────────
          else if ((data['assignModule'][i]['module_name'] == 'HR - Recruitment') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_recruitment'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Salary Calculator') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_salary'] = 1
            
            if (data['assignModule'][i]['add'] == 'true') {
              data['data']['add_Salary_calculator'] = 1
            }
            if (data['assignModule'][i]['edit'] == 'true') {
              data['data']['edit_Salary_calculator'] = 1
            }
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Appointment Letter') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_appointment'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Confirmation Letter') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_confirmation'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - F&F Letter') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_fnf'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Manager Master') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_manager_master'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - User Vacancy') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_vacancy'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Induction Test') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_induction'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Training') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_training'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Employee Attendance') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_attendance'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Mark Attendance') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_mark_attendance'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Employee Pay Slip') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_hr_payslip'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Plant Employee Master') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_plant_employee_master'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Resignation') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_resignation'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Attendance Verification') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_attendance_verification'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'HR - Performance Master') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_HR'] = 1
            data['data']['view_performance_master'] = 1
          }

          // ── IT ────────────────────────────────────────────────────
          else if ((data['assignModule'][i]['module_name'] == 'IT - Resource Allocation') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_IT'] = 1
            data['data']['view_it_resource'] = 1
          }

          // ── Master ────────────────────────────────────────────────
          else if ((data['assignModule'][i]['module_name'] == 'Master - Cron Jobs') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_master_cron'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Master - Designation') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_designation'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Master - Users') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_users'] = 1
              if (data['assignModule'][i]['add'] == 'true') {
              data['data']['add_users_master'] = 1
            }
            if (data['assignModule'][i]['edit'] == 'true') {
              data['data']['edit_users_master'] = 1
            }
            if (data['assignModule'][i]['export'] == 'true') {
              data['data']['export_users_master'] = 1
            }
            if (data['assignModule'][i]['delete'] == 'true') {
              data['data']['delete_users_master'] = 1
            }
            if (data['assignModule'][i]['import'] == 'true') {
              data['data']['import_users_master'] = 1
            }
          }
          else if ((data['assignModule'][i]['module_name'] == 'IT - Mobile Number') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_IT'] = 1
            data['data']['view_mobile_number_master'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Master - OTP Logs') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_otp_log'] = 1
          }
          else if ((data['assignModule'][i]['module_name'] == 'Mobile Number Master') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_IT'] = 1
            data['data']['view_mobile_number_master'] = 1

          }
          else if ((data['assignModule'][i]['module_name'] == 'Designation') && data['assignModule'][i]['view'] == 'true') {
            data['data']['view_master'] = 1
            data['data']['view_designation'] = 1
            if (data['assignModule'][i]['add'] == 'true') {
              data['data']['add_users_designation'] = 1
            }
            if (data['assignModule'][i]['edit'] == 'true') {
              data['data']['edit_users_designation'] = 1
            }
            if (data['assignModule'][i]['export'] == 'true') {
              data['data']['export_users_designation'] = 1
            }
            if (data['assignModule'][i]['delete'] == 'true') {
              data['data']['delete_users_designation'] = 1
            }
            if (data['assignModule'][i]['import'] == 'true') {
              data['data']['import_users_designation'] = 1
            }
          }
        }
      }
    
      else if (data['data']['id'] == '1' && data['data']['user_type'] != 'DMS') {

        data['data']['view_dashboard'] = 1

        data['data']['view_petrol_tracker'] = 1
        data['data']['export_petrol_tracker'] = 1
        data['data']['edit_petrol_tracker'] = 1

        data['data']['view_master'] = 1

        data['data']['view_designation'] = 1
        data['data']['add_users_designation'] = 1
        data['data']['edit_users_designation'] = 1
        data['data']['export_users_designation'] = 1
        data['data']['delete_users_designation'] = 1
        data['data']['import_users_designation'] = 1

        data['data']['view_users'] = 1
        data['data']['add_users_master'] = 1
        data['data']['edit_users_master'] = 1
        data['data']['export_users_master'] = 1
        data['data']['delete_users_master'] = 1
        data['data']['import_users_master'] = 1

        data['data']['view_userReq'] = 1
        data['data']['view_mobile_number_master'] = 1

        data['data']['view_Inventory'] = 1
        data['data']['view_inv_dashboard'] = 1
        data['data']['view_inv_department'] = 1
        data['data']['view_inv_category'] = 1
        data['data']['view_inv_subcategory'] = 1
        data['data']['view_inv_unit'] = 1
        data['data']['view_inv_product'] = 1
        data['data']['view_inv_vendor'] = 1
        data['data']['view_inv_mrn'] = 1
        data['data']['view_inv_stockout'] = 1
        data['data']['view_inv_gatepass'] = 1
        data['data']['view_inv_returnable'] = 1
        data['data']['view_inv_deadstock'] = 1
        data['data']['view_inv_ledger'] = 1

        data['data']['view_Security'] = 1
        data['data']['view_sec_visitor'] = 1
        data['data']['view_sec_gatepass'] = 1
        data['data']['view_sec_patrol'] = 1
        data['data']['view_sec_attendance'] = 1

        data['data']['view_HR'] = 1
        data['data']['view_hr_recruitment'] = 1
        data['data']['view_hr_salary'] = 1
        data['data']['view_hr_vacancy'] = 1
        data['data']['view_hr_appointment'] = 1
        data['data']['view_hr_confirmation'] = 1
        data['data']['view_hr_fnf'] = 1
        data['data']['view_hr_induction'] = 1
        data['data']['view_hr_manager_master'] = 1
        data['data']['view_hr_training'] = 1
        data['data']['view_hr_attendance'] = 1
        data['data']['view_hr_mark_attendance'] = 1
        data['data']['view_hr_payslip'] = 1
        data['data']['view_performance_master'] = 1
        data['data']['view_plant_employee_master'] = 1
        data['data']['view_resignation'] = 1
        data['data']['view_attendance_verification'] = 1

        data['data']['view_IT'] = 1
        data['data']['view_it_resource'] = 1

        data['data']['view_master_cron'] = 1

        data['data']['view_otp_log'] = 1

      }

      if (data.data.type == '1' && data.data.lead_type == 'Drtest') {
        this.channel_partner = true;

        this.st_user = data;

        this.cp_otp = Math.floor(100000 + Math.random() * 900000);

        let value = { "mobile": this.st_user.data.mobile, "otp": this.cp_otp }

        this.serve.auth_rqust(value, "login/verify_otp").subscribe((data: any) => {

        });

      }
      else {
        this.channel_partner = false;
        if (data['message'] == 'Success') {
          this.dialog.success("LogIn", "Success");
          this.st_user = data;
          this.st_user.data.access_level = "1";
          this.st_user.st_log = true;
          localStorage.setItem('st_user', JSON.stringify(this.st_user));
          if (data['data']['user_type'] == 'DMS') {
            this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/distribution-list/1/Channel%20Partner/distribution-detail/' + data['data']['id'] + '/Profile';
            this.router.navigate([this.nexturl]);
          }
          else {
            const desig = '' + (this.st_user.data.designation_id || '');
            // Security portal designations route straight into the PWA.
            // replaceUrl: portal home is the first history entry, so Back exits
            // the PWA instead of going back to login / the admin dashboard.
            if (desig === '57') {
              this.router.navigate(['/security/dashboard'], { replaceUrl: true });
            }
            else if (desig === '121') {
              this.router.navigate(['/security/store'], { replaceUrl: true });
            }
            else if (desig === '127') {
              this.router.navigate(['/security/timekeeper'], { replaceUrl: true });
            }
            else if (this.st_user.data.view_dashboard == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_petrol_tracker == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/petrol-tracker';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_users == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/sale-user-list';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_userReq == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/hr-recruitment';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_mobile_number_master == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/apt-employee-list';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_designation == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/user-designation';
              this.router.navigate([this.nexturl]);
            }
            // ── Inventory per-module landing ──
            else if (this.st_user.data.view_inv_dashboard == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/dashboard';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_department == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/department-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_category == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/category-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_subcategory == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/subcategory-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_unit == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/unit-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_product == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/product-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_vendor == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/vendor-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_mrn == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/mrn';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_stockout == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/stock-out-screen';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_gatepass == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/gate-pass';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_returnable == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/returnable-issue';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_deadstock == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/dead-stock';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_inv_ledger == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/stock-ledger';
              this.router.navigate([this.nexturl]);
            }
            // ── Security / HR / Master per-module landing ──
            else if (this.st_user.data.view_sec_visitor == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/visitor';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_sec_gatepass == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/gate-pass';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_sec_patrol == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/patrol';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_recruitment == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/hr-recruitment';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_salary == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/salary-calculator';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_vacancy == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/user-vacancy';
              this.router.navigate([this.nexturl]);
            }
               else if (this.st_user.data.view_performance_master == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/performance';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_appointment == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/hr-recruitment/appointment-letter';
              this.router.navigate([this.nexturl]);
            }
              else if (this.st_user.data.view_hr_confirmation == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/hr-recruitment/confirmation-letter';
              this.router.navigate([this.nexturl]);
            }
             else if (this.st_user.data.view_hr_manager_master == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/hr-recruitment/manager-master';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_induction == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/induction';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_training == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/induction/training-list';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_attendance == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/employee-attendance';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_hr_payslip == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/employee-pay-slip';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_plant_employee_master == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/plant-employee';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_attendance_verification == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/attendance-verification';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_resignation == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/resignation';
              this.router.navigate([this.nexturl]);
            }
            else if (this.st_user.data.view_master_cron == '1') {
              this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/inv-mgmt/cron-jobs';
              this.router.navigate([this.nexturl]);
            }
          }
        }
        else {
          this.dialog.error("Incorrect UserName or Password");
        }
      }

    }, error => {
      this.savingFlag = false;
    });
  }


  submit_otp() {
    if (this.cp_otp == this.data.otp) {
      this.dialog.success("LogIn", "Success");
      this.st_user.data.access_level = "2";
      this.st_user.st_log = true;
      localStorage.setItem('st_user', JSON.stringify(this.st_user));
      this.router.navigate(['/distribution-detail/' + this.st_user['data'].id]);
    }
    else {
      this.dialog.error("Incorrect Otp");
    }
  }

  visible_password() {
    this.edit_view = true
  }
  not_visible_password() {
    this.edit_view = false
  }

  handlePermissions(assignModule: any[], user: any) {

    // if (!assignModule || !assignModule.length) return;

    assignModule.forEach(module => {

      const name = module.module_name.toLowerCase().replace(/ /g, '_');


      // VIEW
      if (module.view == 'true') { user['view_' + name] = 1; }

      // ADD
      if (module.add == 'true') { user['add_' + name] = 1; }

      // EDIT
      if (module.edit == 'true') { user['edit_' + name] = 1; }

      // DELETE
      if (module.delete == 'true') { user['delete_' + name] = 1; }

      // EXPORT
      if (module.export == 'true') { user['export_' + name] = 1; }

      // IMPORT
      if (module.import == 'true') { user['import_' + name] = 1; }

    });
  }

}
